import React from 'react'
import PropTypes from 'prop-types'
import { ConfigProvider } from 'antd'
import i18n from '../i18n'
import defaultRenderEmpty from 'antd/lib/config-provider/renderEmpty'
import TableEmpty from './TableEmpty'
import zh_CN from 'antd/lib/locale-provider/zh_CN'
import en_US from 'antd/lib/locale-provider/en_US'

class ConfigProviderWithLocale extends React.Component {
    static props = {
        locale: PropTypes.object
    }

    constructor(props) {
        super(props)
        this.state = {
            locale: props.locale || i18n.language
        }

    }

    handleLanguageChange = (locale) => this.setState({ locale })

    componentDidMount() {
        i18n.on('languageChanged', this.handleLanguageChange)
    }

    componentWillUnmount() {
        i18n.off('languageChanged', this.handleLanguageChange)
    }

    renderEmpty = (componentName) => componentName === 'Table' ? <TableEmpty /> : defaultRenderEmpty(componentName)

    render() {
        const { locale } = this.state

        return (
            <ConfigProvider locale={String(locale).startsWith('zh') ? zh_CN : en_US} renderEmpty={this.renderEmpty}>
                {this.props.children}
            </ConfigProvider>
        )
    }
}

export default ConfigProviderWithLocale
